export default __webpack_public_path__ + "static/media/016-dust-storm.0bf8a4c9.svg";